import { en } from './en-US';
import { uk } from './uk-UA';

export const translation = {
  ...en,
  ...uk,
};
